module.exports = __webpack_public_path__ + "img/user-1.9d0fb5ed.png";